
export default {
  keybindings: {
    toggleVisibility: 'alt+shift+p',
  },
  theme: {
    themes: ['default'],
  },
};



/** WEBPACK FOOTER **
 ** ./src/constants/defaultSettings.js
 **/